import { staffClient } from "common/apis/staff";
import BasePageLayout from "components/Layout/BasePage";
import SpinnerMedium from "components/Spinner/Medium";
import PagingTable, { EMPTY_PAGING_TABLE_RET } from "components/Table/Paging";
import PageTitle from "components/Title/Page";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { columns } from "./config";
import { toast } from "react-toastify";
import { randomStr } from "components/Utils/ui";

const ApplyPage = () => {
    const [refreshKey, setRefreshKey] = useState("");

    const fetchApplies = async (page, limit) => {
        const params = {
            offset: (page - 1) * limit,
            limit: limit
        }

        try {
            const ret = await staffClient.get("/apply", { params });
            console.log("[fetchApplies] ret", ret);
            return {
                data: ret.data?.data,
                total: ret.data?.meta?.total,
                page
            }
        } catch (e) {
            console.error("[fetchApplies] error", e);
            return EMPTY_PAGING_TABLE_RET;
        }
    }

    const handleDelete = async (row) => {
        const ok = window.confirm("정말 삭제하시겠습니까?");
        if (!ok) {
            return false;
        }
        try {
            const ret = await staffClient.delete(`/apply/${row.id}`);
            console.log("[handleDelete] ret", ret);
            toast.success("신청서가 삭제되었습니다.");
            setRefreshKey(randomStr());
            return true;
        } catch (e) {
            console.error("[handleDelete] error", e);
            toast.error("신청서 삭제 중 오류가 발생했습니다.");
            return false;
        }
    }

    return (
        <BasePageLayout>
            <PageTitle>신청서 목록</PageTitle>
            <PagingTable
                fetchData={fetchApplies}
                columns={columns}
                isCrudable={true}
                isCreatable={false}
                isEditable={false}
                onDelete={handleDelete}
                refreshKey={refreshKey}
            />
        </BasePageLayout>
    )
}

export default ApplyPage;
